// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialProof_container__sI_Ql","avatars":"SocialProof_avatars__JzDBD","avatar":"SocialProof_avatar__mxQoj"};